import { WORKFLOW_MONITORING_PATH } from '../constants/workflow-monitoring';
import { useMenuStore } from 'vince-core/stores/menuStore';
import { Menu, SubHeader } from 'vince-core/types/menu';
import { ResourceType } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    store.addMenuItem('menus.workflows', '/workflows', 3, Menu.MAIN, undefined, 'pi pi-workflows', {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.workflowStatistics', '/workflow-statistics', 2, Menu.ADMINISTRATION, undefined, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.workflowMonitoring', WORKFLOW_MONITORING_PATH, 8, Menu.ADMINISTRATION, SubHeader.WORKFLOW_MANAGEMENT, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: '*'
    });
});
